import { describeTaskEvidenceShortfall, findBlockingTaskEvidence, Task, TASK_EVIDENCE_OUTCOME_EXPLANATIONS, TASK_EVIDENCE_OUTCOME_LABELS, TaskEvidenceException, TaskEvidenceOutcome } from '@jms/model';
import type { HoverCardRow } from '@workbuddy/ui/v2/components/hover.card';

export type EvidenceDateFormatter = (value: Date | string) => string;

export interface TaskEvidenceCard {
  title: string;
  rows: HoverCardRow[];
}

// The reason is the name saved on the task (D2), never the tag's current name.
export function buildEvidenceExceptionRows(exception: TaskEvidenceException, formatDate: EvidenceDateFormatter): HoverCardRow[] {

  return [
    { label: 'Reason', value: exception.reason?.name ?? '' },
    ...(exception.comment ? [{ label: 'Comment', value: exception.comment }] : []),
    { label: 'Recorded by', value: exception.recordedBy?.name ?? '' },
    { label: 'Recorded on', value: formatDate(exception.recordedOn) },
  ];
}

/** Evidence an exception already explains is not missing for the user, so only what still holds the task is listed, in the completion refusal's words. */
export function buildOutstandingEvidenceRows(task: Partial<Task>): HoverCardRow[] {

  return findBlockingTaskEvidence(task).map(shortfall => ({ value: describeTaskEvidenceShortfall(shortfall) }));
}

/** One card for every surface that hovers an outcome; a task that was not read (portal without Tasks > View) leaves the outcome name alone. */
export function buildTaskEvidenceCard(outcome: TaskEvidenceOutcome, task: Partial<Task> | null | undefined, formatDate: EvidenceDateFormatter): TaskEvidenceCard {

  const title = TASK_EVIDENCE_OUTCOME_LABELS[outcome];
  const explanation = TASK_EVIDENCE_OUTCOME_EXPLANATIONS[outcome];
  if (explanation) return { title, rows: [{ value: explanation }] };
  if (outcome === TaskEvidenceOutcome.Exception && task?.evidenceException) return { title, rows: buildEvidenceExceptionRows(task.evidenceException, formatDate) };
  if (outcome === TaskEvidenceOutcome.Outstanding && task) return { title, rows: buildOutstandingEvidenceRows(task) };

  return { title, rows: [] };
}
